'use strict';

// Accessors for the heavy crypto loaded as <script> globals (kept out of our bundle):
//   window.bsv     -> @smartledger/bsv UMD bundle
//   window.argon2  -> argon2-browser (Argon2id, wasm)
// plus a WebCrypto SubtleCrypto handle. Throwing here gives clear errors if a
// <script> tag is missing rather than a vague "undefined" later.

function g() {
  return typeof window !== 'undefined' ? window : globalThis;
}

function getBsv() {
  const bsv = g().bsv;
  if (!bsv) throw new Error('SmartLedger bundle (window.bsv) not loaded');
  return bsv;
}

function getArgon2() {
  const a = g().argon2;
  if (!a) throw new Error('argon2-browser (window.argon2) not loaded');
  return a;
}

function getCrypto() {
  const c = g().crypto;
  if (!c || !c.subtle) throw new Error('WebCrypto (crypto.subtle) unavailable');
  return c;
}

function subtle() {
  return getCrypto().subtle;
}

function randomBytes(n) {
  const b = new Uint8Array(n);
  getCrypto().getRandomValues(b);
  return b;
}

module.exports = { getBsv, getArgon2, getCrypto, subtle, randomBytes };
